var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { paths } from "frontend/src/pages/paths/index";
import { Role } from "frontend/src/shared/types/role";
import { HomePage } from "./home";
import { PlaylistsPage } from "./playlists/index";
import { EditPlaylistPage } from "./playlists/edit";
import { ViewPlaylistPage } from "./playlists/view";
import { TimetablesPage } from "./timetables/index";
import { EditTimetablePage } from "./timetables/edit";
import { ProgramsPage } from "./programs/index";
import { EditProgramPage } from "./programs/edit";
import { AdvertisementsPage } from "./audio-advertisements/index";
import { DevicesPage } from "./devices/index";
import { DeviceSettingsPage } from "./devices/edit";
var path = paths.business.owner;
export var businessOwnerRoutes = [
    {
        path: path.home(),
        Component: HomePage,
    },
    {
        path: path.playlists.edit(":id"),
        Component: EditPlaylistPage,
    },
    {
        path: path.playlists.view(":id"),
        Component: ViewPlaylistPage,
    },
    {
        path: path.playlists.index(":type"),
        Component: PlaylistsPage,
    },
    {
        path: path.timetables.index(),
        Component: TimetablesPage,
    },
    {
        path: path.timetables.edit(":id"),
        Component: EditTimetablePage,
    },
    {
        path: path.programs.index(),
        Component: ProgramsPage,
    },
    {
        path: path.programs.edit(":id"),
        Component: EditProgramPage,
    },
    {
        path: path.files.index(),
        Component: AdvertisementsPage,
    },
    {
        path: path.devices.index(),
        Component: DevicesPage,
    },
    {
        path: path.devices.settings(":id"),
        Component: DeviceSettingsPage,
    },
].map(function (route) { return (__assign(__assign({}, route), { role: Role.BusinessOwner })); });
